import React, { useEffect, useRef, useState } from "react";
import { mediaUrl } from "../../lib/format";

export function SmartImage({ src, alt = "", className = "", priority = false, ...rest }) {
  const [loaded, setLoaded] = useState(false);
  const url = mediaUrl(src);
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {!loaded && <div className="absolute inset-0 skeleton" />}
      {url && (
        <img
          src={url} alt={alt} loading={priority ? "eager" : "lazy"} decoding="async"
          fetchPriority={priority ? "high" : "auto"}
          onLoad={() => setLoaded(true)}
          className={`h-full w-full object-cover transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
          {...rest}
        />
      )}
      {!url && <div className="absolute inset-0 flex items-center justify-center bg-zinc-900 text-zinc-600 text-xs">sem imagem</div>}
    </div>
  );
}

// Video that autoplays when in viewport. The poster/cover paints instantly and the
// video fades in only once it can actually play — the Hero is never empty or black,
// and the download never blocks the rest of the menu.
export function ViewportVideo({ src, poster, className = "", showControls = false, priority = false }) {
  const ref = useRef(null);
  const [ready, setReady] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const url = mediaUrl(src);
  const posterUrl = mediaUrl(poster);
  // Load the video only after the page has loaded so the poster + above-the-fold
  // images get bandwidth first; the video then streams in the background.
  useEffect(() => {
    let t;
    const start = () => { t = setTimeout(() => setShowVideo(true), 300); };
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
    return () => { clearTimeout(t); window.removeEventListener("load", start); };
  }, []);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) el.play().catch(() => {});
        else el.pause();
      },
      { threshold: 0.5 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [url, showVideo]);
  if (!url) return null;
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {posterUrl && (
        <img
          src={posterUrl} alt="" aria-hidden="true" decoding="async"
          loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-500 ${ready ? "opacity-0" : "opacity-100"}`}
        />
      )}
      {showVideo && (
        <video
          ref={ref} src={url} poster={posterUrl}
          muted loop playsInline autoPlay
          preload="auto" controls={showControls}
          onCanPlay={() => setReady(true)}
          onPlaying={() => setReady(true)}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${ready ? "opacity-100" : "opacity-0"}`}
        />
      )}
    </div>
  );
}
